import { render, staticRenderFns } from "./index.vue?vue&type=template&id=482ece8e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=482ece8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ece8e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/app/components/banner.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
